import type {
  ContentGroupItem,
  MediaLibraryStoreContentFolder,
  MediaLibraryStoreContentGroup,
} from "cortex/ui/src/fleet/view/media-library/model";

type FolderById = Record<string, MediaLibraryStoreContentFolder>;
type FolderContentLike = {
  folder_id?: string | number | null;
  id: string | number;
};

function addContentToFolder(
  byId: FolderById = {},
  data: ContentGroupItem = {} as ContentGroupItem,
) {
  const newState = { ...byId };
  if (data.folder_id) {
    const folderId = String(data.folder_id);
    newState[folderId].contents = [
      ...(newState[folderId].contents || []),
      data,
    ];
  }
  return newState;
}

function getUcContentsMap(data: FolderContentLike[] = []) {
  return data
    .filter((uc) => uc.folder_id)
    .reduce<Record<string, Record<string, FolderContentLike>>>(
      (ucContentsMap, uc) => {
        const folderId = String(uc.folder_id);
        const contentId = String(uc.id);
        if (ucContentsMap[folderId]) {
          ucContentsMap[folderId][contentId] = uc;
        } else {
          ucContentsMap[folderId] = {
            [contentId]: uc,
          };
        }
        return ucContentsMap;
      },
      {},
    );
}

function updateContentInFolder(
  byId: FolderById = {},
  data: ContentGroupItem[] = [],
) {
  const newState = { ...byId };
  const ucContentsMap = getUcContentsMap(data);

  Object.entries(ucContentsMap).forEach(([folderId, contentsMap]) => {
    const folder = newState[folderId];
    const { contents = [] } = folder;

    newState[folderId] = {
      ...folder,
      contents: contents.map((c) => {
        const contentId = String(c.id);
        return contentsMap[contentId]
          ? (contentsMap[contentId] as ContentGroupItem)
          : c;
      }),
    };
  });

  return newState;
}

function updateContentGroupInFolder(
  byId: FolderById = {},
  data: MediaLibraryStoreContentGroup[] = [],
) {
  const newState = { ...byId };
  const ucContentsMap = getUcContentsMap(data);

  Object.entries(ucContentsMap).forEach(([folderId, contentsMap]) => {
    const folder = newState[folderId];
    const { content_groups = [] } = folder;

    newState[folderId] = {
      ...folder,
      content_groups: content_groups.map((c) => {
        const contentId = String(c.id);
        return contentsMap[contentId]
          ? (contentsMap[contentId] as MediaLibraryStoreContentGroup)
          : c;
      }),
    };
  });

  return newState;
}

export {
  addContentToFolder,
  getUcContentsMap,
  updateContentGroupInFolder,
  updateContentInFolder,
};
